import React from 'react'

const BotPage = React.lazy(() => import('./BotPage').then(module => ({ default: module.BotPage })))
const HomePage = React.lazy(() => import('./HomePage').then(m => ({ default: m.HomePage })))
const WizardPage = React.lazy(() => import('./WizardPage').then(m => ({ default: m.WizardPage })))

const CallsTablePage = React.lazy(() =>
  import('./CallsTablePage').then(m => ({ default: m.CallsTablePage }))
)
const AnalyticsPage = React.lazy(() =>
  import('./AnalyticsPage').then(m => ({ default: m.AnalyticsPage }))
)
const VoicebuilderPage = React.lazy(() =>
  import('./VoicebuilderPage').then(m => ({ default: m.VoicebuilderPage }))
)
const FeatureSetterPage = React.lazy(() =>
  import('./FeatureSetterPage').then(m => ({ default: m.FeatureSetterPage }))
)
const TeamManagementPage = React.lazy(() =>
  import('./TeamManagementPage').then(m => ({ default: m.TeamManagementPage }))
)
const MarketplaceSignupPage = React.lazy(() =>
  import('./MarketplaceSignup').then(m => ({ default: m.MarketplaceSignupPage }))
)
const CallsRecFilePage = React.lazy(() =>
  import('./CallsRecFilePage').then(m => ({ default: m.CallsRecFilePage }))
)
const CampaignContactsSheetPage = React.lazy(() =>
  import('./CampaignTablePage').then(m => ({ default: m.CampaignContactsSheetPage }))
)
const ConversationsTablePage = React.lazy(() =>
  import('./ConversationsTablePage').then(m => ({ default: m.ConversationsTablePage }))
)

const RecordedTesterRunPage = React.lazy(() =>
  import('./RecordedTesterRunPage').then(m => ({ default: m.RecordedTesterRunPage }))
)

const BotTesterScenariosPage = React.lazy(() =>
  import('./BotTesterScenariosPage').then(m => ({ default: m.BotTesterScenariosPage }))
)

export { callsListUrlGetters } from './CallsTablePage'

export {
  BotPage,
  BotTesterScenariosPage,
  HomePage,
  WizardPage,
  CallsTablePage,
  AnalyticsPage,
  VoicebuilderPage,
  FeatureSetterPage,
  TeamManagementPage,
  MarketplaceSignupPage,
  CallsRecFilePage,
  CampaignContactsSheetPage,
  ConversationsTablePage,
  RecordedTesterRunPage
}
